import React from "react";
import { ExpansionPanelDetails as AccordionDetails, ExpansionPanelSummary as AccordionSummary, ExpansionPanel as Accordion } from "@material-ui/core";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";

export default function ListExpansion(props) {
  const { footer, children, header, icon, description, defaultExpanded } = props;

  return (
    <div>
      <Accordion className="smooth-shadow" defaultExpanded={defaultExpanded === true} style={{ marginTop: "1px", borderRadius: "0px" /*  borderTop: '2px solid #d3cece69 ', borderBottom: '2px solid #d3cece69' */ }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1c-content" id="panel1c-header" style={{ color: "#222", maxHeight: "33.5px", minHeight: "33.5px" /*  backgroundColor: '#2f353a'  */ }}>
          <div className="list-icon" style={{ width: "100%", display: "inline-flex" }}>
            {icon && !icon.toString().includes("fa") ? icon : null}
            <div style={{ marginLeft: 15, marginTop: 5, color: "#222", fontWeight: "600", fontSize: "10px", color: "rgb(81, 97, 103)", textTransform: "uppercase", borderBottom: "0px !important" }}>
              <SystemLabel name={description}></SystemLabel>{" "}
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails style={{ display: "inline-block", padding: "8px 12px 24px", width: "100%" }}>
          <hr style={{ marginTop: "-8px" }} />
          {children}
        </AccordionDetails>
        <Divider />
        {footer ? (
          <ExpansionPanelActions>
            <Button size="small">Cancel</Button>
            <Button size="small" color="primary">
              Save
            </Button>
          </ExpansionPanelActions>
        ) : null}
      </Accordion>
    </div>
  );
}

export function ModeratorExpansionList(props) {
  const { footer, children, header, icon, description, expanded, summaryContent } = props;
  return (
    <div style={{ width: "100%", padding: "0px 25px" }}>
      <Accordion defaultExpanded={expanded} style={{ marginTop: "5px", boxShadow: "none", borderRadius: "0px", background: "#2b2b2b" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon style={{ color: "#eee" }} />} aria-controls="panel1c-content" id="panel1c-header" style={{ color: "#eee" /*  backgroundColor: '#2f353a'  */ }}>
          <div style={{ width: "100%" }}>
            <Typography style={{ color: "#222", fontWeight: "600", fontSize: "12px", color: "#eee", textTransform: "uppercase", borderBottom: "0px !important" }}>
              <SystemLabel name={description}></SystemLabel>{" "}
            </Typography>
          </div>
          <div>{summaryContent}</div>
        </AccordionSummary>
        <AccordionDetails style={{ display: "inline-block", padding: "8px 12px 24px", width: "100%" }}>
          <hr />
          {children}
        </AccordionDetails>
        <Divider />
        {footer ? (
          <ExpansionPanelActions>
            <Button size="small">Cancel</Button>
            <Button size="small" color="primary">
              Save
            </Button>
          </ExpansionPanelActions>
        ) : null}
      </Accordion>
    </div>
  );
}
